import { Routes, Route } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Wall from './pages/Wall';
import Submit from './pages/Submit';
import Random from './pages/Random';
import RegretPage from './pages/RegretPage';
import FAQ from './pages/FAQ';
import Layout from './components/Layout';

// Replace with your Stripe publishable key
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_test_placeholder');

function App() {
  return (
    <Elements stripe={stripePromise}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Wall />} />
          <Route path="submit" element={<Submit />} />
          <Route path="random" element={<Random />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="r/:id" element={<RegretPage />} />
        </Route>
      </Routes>
    </Elements>
  );
}

export default App;
